import { useCallback } from 'react';
import { useToast } from 'hooks/useToast';

import * as releaseApi from 'api/releaseApi';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import {
  listSelectors,
  listActions,
} from 'store/reducers/releaseReducers/releaseComponentReducer/listSlice';
import { editActions } from 'store/reducers/releaseReducers/releaseComponentReducer/editSlice';
import { ReleaseComponent } from 'types/releaseComponent';

/**
 * リリースコンポーネント一覧 store の実装をコンポーネントから隠すための中間層
 * @returns selector と action のラッパー
 */
export const useListStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const loading = useAppSelector(listSelectors.loading);
  const releaseComponents = useAppSelector(listSelectors.releaseComponents);

  const fetchReleaseComponents = useCallback(async () => {
    dispatch(listActions.loadStarted());
    const result = await releaseApi.fetchReleaseComponents();
    if (result.ok) {
      dispatch(
        listActions.fetchReleaseComponentSuccess({
          releaseComponents: result.value,
        }),
      );
    } else {
      toast({
        status: 'error',
        description: `コンポーネント一覧の取得に失敗しました: ${result.err.message}`,
      });
    }
    dispatch(listActions.loadEnded());
  }, [dispatch, toast]);

  const onOpenModal = useCallback(
    (releaseComponent: ReleaseComponent) => {
      dispatch(editActions.modalOpened(releaseComponent));
    },
    [dispatch],
  );

  return {
    /** 一覧ロード状態 */
    loading,
    /** リリースコンポーネント一覧データ */
    releaseComponents,
    /** リリースコンポーネント一覧を取得 */
    fetchReleaseComponents,
    /** クローラー詳細を表示 */
    onOpenModal,
  };
};
